import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spin } from "antd";
import { selectCompactBrandLogo } from "@wavvest/shared-utils";
import { useAuth } from "../contexts/AuthContext";
import { useTheme } from "../contexts/ThemeContext";
import { useAppSelector } from "../store/hooks";
import { selectRiaProfile } from "../store/features/userinfo/userinfoSlice";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const { theme } = useTheme();
  const riaProfile = useAppSelector(selectRiaProfile);
  const compactLogoUri = selectCompactBrandLogo(riaProfile?.profile ?? {}, theme);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 24,
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {compactLogoUri ? (
          <img
            src={compactLogoUri}
            alt=""
            aria-hidden="true"
            style={{ maxWidth: 120, maxHeight: 64, objectFit: "contain" }}
          />
        ) : null}
        <Spin size="large" tip="loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
